import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  USER_ACTIVATION_SUCCESS,
  USER_ACTIVATION_FAIL,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  SET_AUTH_MESSAGE,
} from './actionTypes';

import * as AuthService from '../../services/auth.service';

export const register =
  (name, surname, email, phoneNumber, password, company, job, license) =>
  (dispatch) => {
    return AuthService.register(
      name,
      surname,
      email,
      phoneNumber,
      password,
      company,
      job,
      license
    ).then(
      (response) => {
        dispatch({
          type: REGISTER_SUCCESS,
        });

        dispatch({
          type: SET_AUTH_MESSAGE,
          payload: response,
        });
        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();

        dispatch({
          type: REGISTER_FAIL,
        });

        dispatch({
          type: SET_AUTH_MESSAGE,
          payload: message,
        });
        return Promise.reject();
      }
    );
  };

export const login = (email, password) => (dispatch) => {
  return AuthService.login(email, password).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString();
      dispatch({
        type: LOGIN_FAIL,
      });
      dispatch({
        type: SET_AUTH_MESSAGE,
        payload: message,
      });
      return Promise.reject();
    }
  );
};

export const logout = () => (dispatch) => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};

export const forgotPassword = (email) => (dispatch) => {
  return AuthService.forgotPassword(email).then(
    (response) => {
      dispatch({
        type: FORGOT_PASSWORD_SUCCESS,
      });

      dispatch({
        type: SET_AUTH_MESSAGE,
        payload: response,
      });
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString();
      dispatch({
        type: FORGOT_PASSWORD_FAIL,
      });
      dispatch({
        type: SET_AUTH_MESSAGE,
        payload: message,
      });
      return Promise.reject();
    }
  );
};

export const resetPassword = (password, token) => (dispatch) => {
  return AuthService.resetPassword(password, token).then(
    (response) => {
      dispatch({
        type: RESET_PASSWORD_SUCCESS,
      });
      dispatch({
        type: SET_AUTH_MESSAGE,
        payload: response.data,
      });
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString();
      dispatch({
        type: RESET_PASSWORD_FAIL,
      });
      dispatch({
        type: SET_AUTH_MESSAGE,
        payload: message,
      });
      return Promise.reject();
    }
  );
};

export const userActivation = (verifyEmailToken) => (dispatch) => {
  return AuthService.verifyEmail(verifyEmailToken).then(
    (response) => {
      dispatch({
        type: USER_ACTIVATION_SUCCESS,
      });
      dispatch({
        type: SET_AUTH_MESSAGE,
        payload: response.data,
      });
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString();
      dispatch({
        type: USER_ACTIVATION_FAIL,
      });
      dispatch({
        type: SET_AUTH_MESSAGE,
        payload: message,
      });
      return Promise.reject();
    }
  );
};
